<template>
    <footer class="bg-blue-dark px-4 py-6">
        <div class="max-w-screen-lg mx-auto">
            <div
                class="flex flex-col md:flex-row items-center justify-center md:justify-between mb-6"
            >
                <router-link :to="{ name: 'home' }">
                    <app-image
                        width="196"
                        height="66"
                        url="logoviejo.png"
                        is-local
                        alt="Pinguinitos logo"
                        class="mb-6 md:mb-0"
                    ></app-image>
                </router-link>

                <div
                    class="flex flex-wrap justify-center font-secondary text-lg text-white md:ml-4"
                >
                    <div class="w-1/2 sm:w-auto sm:mr-6 text-right">
                        <router-link class="mr-6" :to="{ name: 'about' }">
                            {{ $config("ABOUT_FOOTER") }}
                        </router-link>

                        <span>|</span>
                    </div>

                    <div class="w-1/2 sm:w-auto sm:mr-6 pl-6 sm:pl-0">
                        <router-link class="sm:mr-6" :to="{ name: 'series' }">
                            {{ $config("SERIES_FOOTER") }}
                        </router-link>

                        <span class="hidden sm:inline">|</span>
                    </div>

                    <div class="w-1/2 sm:w-auto sm:mr-6 text-right">
                        <router-link class="mr-6" :to="{ name: 'games' }">
                            {{ $config("JUEGOS") }}
                        </router-link>
                        <span>|</span>
                    </div>

                    <div class="w-1/2 sm:w-auto pl-6 sm:pl-0">
                        <router-link class="mr-6" :to="{ name: 'contact' }">
                            {{ $config("CONTACT") }}
                        </router-link>
                    </div>
                </div>
            </div>

            <div class="flex flex-col md:flex-row mb-6">
                <div
                    class="md:w-1/2 font-secondary text-white text-base text-center md:text-left mb-6"
                >
                    <p>{{ $config("DOWNLOAD") }}</p>
                </div>

                <div class="flex flex-wrap items-center justify-center">
                    <a
                        href="https://apps.apple.com/us/app/pinguinitos/id1285618865?l=es"
                        target="_blank"
                        rel="noreferrer"
                        class="mr-4 mb-4"
                        alt="Pinguinitos iTunes"
                    >
                        <app-image
                            width="161"
                            height="50"
                            url="ios.png"
                            is-local
                            alt="Pinguinitos iTunes"
                        >
                        </app-image>
                    </a>

                    <a
                        href="https://play.google.com/store/apps/details?id=com.somosnext.pinguinitos"
                        target="_blank"
                        rel="noreferrer"
                        class="mr-4 mb-4"
                        alt="Pinguinitos Play Store"
                    >
                        <app-image
                            width="161"
                            height="50"
                            url="android.png"
                            is-local
                            alt="Pinguinitos Play Store"
                        >
                        </app-image>
                    </a>

                    <a
                        href="https://channelstore.roku.com/en-gb/details/270309/pinguinitos"
                        target="_blank"
                        rel="noreferrer"
                        class="mb-4"
                        alt="Pinguinitos Roku"
                    >
                        <app-image
                            width="161"
                            height="50"
                            url="rokustore.png"
                            is-local
                            alt="Pinguinitos Roku"
                        >
                        </app-image>
                    </a>
                </div>
            </div>

            <div class="flex items-center justify-center pb-3 border-b-2 mb-6">
                <a
                    href="https://www.facebook.com/pinguinitostv"
                    target="_blank"
                    aria-label="facebook"
                    alt="facebook"
                    ><font-awesome-icon
                        alt="facebook"
                        :icon="['fab', 'facebook']"
                        class="text-3xl text-white mr-6"
                /></a>
                <a
                    href="https://www.youtube.com/pinguinitos/"
                    target="_blank"
                    aria-label="youtube"
                    alt="youtube"
                    ><font-awesome-icon
                        alt="youtube"
                        :icon="['fab', 'youtube']"
                        class="text-3xl text-white mr-6"
                /></a>
                <a
                    href="https://twitter.com/Pinguinitos_TV"
                    target="_blank"
                    aria-label="twitter"
                    alt="twitter"
                    ><font-awesome-icon
                        alt="twitter"
                        :icon="['fab', 'twitter']"
                        class="text-3xl text-white mr-6"
                /></a>
                <a
                    href="https://www.instagram.com/pinguinitos.tv/"
                    target="_blank"
                    aria-label="instagram"
                    alt="instagram"
                    ><font-awesome-icon
                        alt="instagram"
                        :icon="['fab', 'instagram']"
                        class="text-3xl text-white"
                /></a>
            </div>

            <div
                class="flex flex-col-reverse md:flex-row items-center justify-around"
            >
                <div>
                    <span class="font-primary text-base text-white"
                        >&copy; {{ new Date().getFullYear() }}, Pingüinitos All
                        Rights Reserved</span
                    >
                </div>

                <div
                    class="flex items-center justify-center flex-col sm:flex-row mb-4 md:mb-0 md:ml-4"
                >
                    <router-link
                        :to="{ name: 'privacy-policy' }"
                        class="font-secondary text-base text-white sm:mr-6"
                    >
                        {{ $config("PPRIVACIDAD") }}
                    </router-link>

                    <router-link
                        :to="{ name: 'terms-of-use' }"
                        class="font-secondary text-base text-white"
                    >
                        {{ $config("TERMINOS") }}
                    </router-link>
                </div>

                <app-image
                    width="169"
                    height="55"
                    url="somosnext.png"
                    is-local
                    alt="Somosnext logo"
                    class="mb-4 md:mb-0 md:ml-4"
                ></app-image>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "foot"
};
</script>
